export default {
    achievement_locked: 'Locked item',
    all_avatars: 'Express your personality and your tastes with incredible avatars',
    all_skins: 'Customize your BeeReaders experience with your favorite skin',
    all_the_books: 'Redeem your rewards for books full of exciting adventures and knowledge',
    avatars: 'Avatars',
    books: 'Books',
    buy: 'Buy',
    buy_this_book: 'Buy this book',
    buy_this_pack: 'Buy this pack',
    buy_this_skin: 'Buy this skin',
    cost: 'cost:',
    favorites: 'Favorites',
    insufficient_beecoins: 'Insufficient beecoins',
    item_successfully_purchased: 'Item purchased <b>successfully</b>',
    learn_more: 'Learn more',
    magazines: 'Magazines',
    next: 'Next',
    of: ' of ',
    pack_of: 'Pack of',
    preview: 'Preview',
    previous: 'Previous',
    return: 'Return',
    search: 'What would you like to read today?',
    skins: 'Skins',
    this_book: 'This book',
    this_pack: 'This pack',
    this_skin: 'This skin',
    you_have: 'You have',
}